<template>
  <div class="home">

  </div>
</template>

<script>
// @ is an alias to /src
import Client, { shared, Modal, Redirect } from '@shoplinedev/appbridge'
import { Oauth } from '@shoplinedev/appbridge'
export default {
  name: "HomeView",
  created() {
    let handle = new URL(window.location).searchParams.get('handle')
    let appkey = new URL(window.location).searchParams.get('appkey')
    // 配置必须从当前环境的 API 获取，避免测试前端误用生产环境旧权限。
    fetch(this.$api_url + '/api/ShoplineApp/settings', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        handle: handle
      })
    }) 
      .then(res => res.json())
      .then(res => {
        if (res.status === 1) {
          const app = Client.createApp({
            appKey: appkey,
            host: shared.getHost()
          })
          // scope 和 customField 均以后端返回值为准，编码后透传给 SHOPLINE OAuth 回调。
          const query = new URLSearchParams({
            appKey: appkey,
            responseType: 'code',
            scope: res.data.scope,
            redirectUri: `${this.$system_url}/about`,
            customField: res.data.customField
          })
          window.location.href = `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?${query.toString()}`
        }
      })
  }
};
</script>
